import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Typography, useTheme } from '@mui/material';
import React from 'react';
import { AppPageHeader } from '../AppPageHeader';
/**
 * @deprecated replaced by `GlobalApp`, to control scrolling behavior use `FullHeightPage`, do not use together with `GlobalApp` in new code.
 */
export const AppPageHeader1 = (props) => {
    const theme = useTheme();
    return (React.createElement(AppPageHeader, null,
        React.createElement(Typography, { sx: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                marginRight: props.onCreate ? theme.spacing(2) : 0,
            }, variant: 'h5', "data-test": 'app-page-header1-title' }, props.title),
        props.onCreate && (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: { flexShrink: 0 } },
                React.createElement(Button, { variant: 'contained', color: 'primary', "data-test": 'app-page-header1-new-button', startIcon: React.createElement(AddIcon, null), onClick: props.onCreate }, props.createButtonText || 'New'))))));
};
